import moment from 'moment'

/**
 * Parse a date string in the user's local timezone.
 */
export function parseDate(date) {
    if (date instanceof Date) {
        return moment([date.getFullYear(), date.getMonth(), date.getDate()])
    }
    if (typeof date === 'string') {
        return moment(date)
    }
    return moment(date)
}

/**
 * Parse a date string as UTC. Use for campaign launch_date / end_date.
 */
export function parseDateUTC(date) {
    if (date instanceof Date) {
        return moment.utc([date.getFullYear(), date.getMonth(), date.getDate()])
    }
    if (typeof date === 'string') {
        return moment.utc(date)
    }
    return moment.utc(date)
}

export function formatDate(date, format = 'DD/MM/YYYY, H:mm:ss') {
    if (!date) return '-'
    const m = parseDate(date)
    if (!m.isValid()) return date
    return m.format(format)
}

export function formatDateShort(date) {
    if (!date) return '-'
    return parseDate(date).format('DD/MM/YYYY')
}

export function formatDateTime(date) {
    if (!date) return '-'
    const m = parseDate(date)
    if (!m.isValid()) return date
    return m.format('DD/MM/YYYY H:mm')
}

export function shortenName(name, maxLength = 16) {
    if (!name) return '-'
    if (name.length <= maxLength) return name
    const parts = name.trim().split(/\s+/)
    if (parts.length <= 1) return name
    return `${parts[0]} ${parts[parts.length - 1][0]}.`
}

export function getQuarter(date) {
    if (!date) return null
    const m = parseDate(date)
    if (!m.isValid()) return null
    return {
        label: `Q${m.quarter()} ${m.year()}`,
    }
}
